"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CASETRUST_BUSINESS_FLAG_LABELS = void 0;
exports.casetrustDaysBetween = casetrustDaysBetween;
exports.casetrustIsStaleActivity = casetrustIsStaleActivity;
exports.casetrustIsBusinessFlagged = casetrustIsBusinessFlagged;
exports.evaluateCasetrustBusinessFlag = evaluateCasetrustBusinessFlag;
exports.casetrustProjectFlagActivityDate = casetrustProjectFlagActivityDate;
exports.isCasetrustProjectFlagged = isCasetrustProjectFlagged;
const MS_PER_DAY = 86_400_000;
exports.CASETRUST_BUSINESS_FLAG_LABELS = {
    never_transacted: "Never transacted",
    no_recent_activity: "No recent activity",
    healthy: "Healthy",
};
/** Whole calendar days from `earlier` up to `later` (local calendar days). */
function casetrustDaysBetween(later, earlier) {
    const start = new Date(later.getFullYear(), later.getMonth(), later.getDate());
    const end = new Date(earlier.getFullYear(), earlier.getMonth(), earlier.getDate());
    return Math.floor((start.getTime() - end.getTime()) / MS_PER_DAY);
}
function casetrustIsStaleActivity(activityDate, days, asOf) {
    if (!activityDate)
        return true;
    return casetrustDaysBetween(asOf, activityDate) >= days;
}
function casetrustIsBusinessFlagged(state) {
    return state !== "healthy";
}
function evaluateCasetrustBusinessFlag(input, days, asOf) {
    const anchor = input.lastProjectCreatedDate ?? input.joinDate;
    if (!input.hasEverMovedMoney) {
        return casetrustIsStaleActivity(anchor, days, asOf) ? "never_transacted" : "healthy";
    }
    if (casetrustIsStaleActivity(anchor, days, asOf)) {
        return "no_recent_activity";
    }
    return "healthy";
}
function casetrustProjectFlagActivityDate(input) {
    if (input.lastReleaseDate !== null)
        return input.lastReleaseDate;
    if (!input.hasAnyPayIn)
        return input.createdDate;
    return input.lastPayInDate ?? input.createdDate;
}
function isCasetrustProjectFlagged(input, days, asOf) {
    if (input.status === "completed")
        return false;
    if (input.inEscrow > 0)
        return false;
    return casetrustIsStaleActivity(casetrustProjectFlagActivityDate(input), days, asOf);
}
